export default __webpack_public_path__ + "static/media/eb-pro-blk-banner-2.b09dcd4e.jpg";